import * as types from '../../mutation-types'
import projects from './projects'
import businessProjects from './businessProjects'
import billing from './billing'
import scheduler from './scheduler'
import usersManager from './usersManager'
import usersControl from './usersControl'
import keywordsRanking from './keywordsRanking'
import onlineMonitor from './onlineMonitor'
import termsFilter from './termsFilter'
import articles from './articles'
import utils from './utils'
import articleWriter from './articleWriter'
import categoriesFetcher from "./categoriesFetcher"
import passwordReset from './passwordReset'
import changePassword from './changePassword'
import potentialCustomerReport from "./potentialCustomerReport";
import dashboard from './dashboard'
import titleResearcher from './titleResearcher'

// show: meta.label -> name
// name: component name
// meta.label: display label

const state = {
  items: getItems(),
  authorizedItems: getItems()
}

function getItems() {
  return [
    dashboard,
    projects,
    businessProjects,
    articles,
    scheduler,
    usersManager,
    usersControl,
    keywordsRanking,
    billing,
    onlineMonitor,
    termsFilter,
    utils,
    articleWriter,
    categoriesFetcher,
    potentialCustomerReport,
    passwordReset,
    changePassword,
    titleResearcher
  ]
}

const mutations = {
  [types.EXPAND_MENU](state, menuItem) {
    if (menuItem.index > -1) {
      if (state.authorizedItems[menuItem.index] && state.authorizedItems[menuItem.index].meta) {
        state.authorizedItems[menuItem.index].meta.expanded = menuItem.expanded
      }
    } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
      menuItem.authorizedItems.meta.expanded = menuItem.expanded
    }
  },
  [types.UPDATE_EDIT_LABEL](state, opts) {
    state.authorizedItems.find(i => i.name === 'Projects').children.map(c => c.children.find(c => c.name === opts.routeName))
      .find(c => !!c).meta.label = opts.label
  },
  [types.FILTER_UNAUTHORIZED_ITEMS](state, user) {
    let allowedSystems = user.allowed_systems

    state.items.forEach(i => {
      i.meta.expanded = false
    })

    state.authorizedItems = user.is_admin ? state.items : getAuthorizedItems()

    function getAuthorizedItems() {
      let items = JSON.parse(JSON.stringify(state.items)) // clone

      let authorizedItems = items.filter(i => {
        return i.system !== 'scheduler' ? allowedSystems[i.system] : allowedSystems.scheduler !== 'NONE'
      })

      if (user.is_account_manager) {
        authorizedItems.push(...state.items.filter(i => i.auth === 'accountManager'))
      }

      return authorizedItems
    }
  }
}

export default {
  state,
  mutations
}
